/**
 * 全局状态
 */
const triggerEvtents = {
    namespaced: true,
    state: {
        getMenusData: false,
        getSchemaData: false,
        routerTriggerFn: false,
        clearSearchCondition: false,
        resetSideNav: false,
        initSearchCondition: false,
        snackbar: false,
        snackbarInfor: null,
        resetFilterCondition: false
    },
    mutations: {
        updateGetMenusData(state) {
            state.getMenusData = !state.getMenusData;
        },
        updateGetSchemaData(state) {
            state.getSchemaData = !state.getSchemaData;
        },
        updateRouterTriggerFn(state) {
            state.routerTriggerFn = !state.routerTriggerFn;
        },
        updateClearSearchCondition(state) {
            state.clearSearchCondition = !state.clearSearchCondition;
        },
        updateResetSideNav(state) {
            state.resetSideNav = !state.resetSideNav;
        },
        updateInitSearchCondition(state) {
            state.initSearchCondition = !state.initSearchCondition;
        },
        updateSnackbar(state, info) {
            state.snackbar = !state.snackbar;
            state.snackbarInfor = info;
        },
        updateResetFilterCondition(state) {
            state.resetFilterCondition = !state.resetFilterCondition;
        }
    },
    getters: {}
};
export default triggerEvtents;
